import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { EINVOICE_TRANX_TYPE } from '@core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

@Component({
  selector: 'app-einvoice-tranx-type-select',
  templateUrl: './einvoice-tranx-type-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    ViewItemComponent
  ],
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceTranxTypeSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceTranxTypeSelectComponent implements ControlValueAccessor {
  statusLabel: { [key: number]: string } = {};

  get options() {
    if (this.showCode) {
      return EINVOICE_TRANX_TYPE.sort((a, b) => a.value - b.value);
    }

    return EINVOICE_TRANX_TYPE;
  }

  @Input() value: number = 0;
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() allowEdit = true;
  @Input() showCode = false;
  @Output() valueChange = new EventEmitter<number>();

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    return this.getLabel(item);
  }

  getLabel(item: any) {
    if (item) {
      if (this.showCode) return `${item.value} - ${item.label}`;
      return item.label;
    }
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.valueChange.emit(this.value);
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
